import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import CommonTable from "../../../components/comman/CommonTable";
import EditIcon from "../../../components/Icons/EditIcon";
import MainHeading from "../../../components/comman/MainHeading";
import PlusIcon from "../../../components/Icons/PlusIcon";
import AddCustomerCompanyModal from "./AddCustomerCompanyModal";

export default function CustomerDetail() {
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [customerDetail, setCustomerDetail] = useState({});
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };
  const [EditData, setEditData] = useState("");

  useEffect(() => {
    GetCustomerDetail();
  }, []);

  const GetCustomerDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_customer_detail + `?customerId=${id}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setCustomerDetail(response?.data);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const HandleUpdate = (data) => {
    setEditData(data);
    toggle();
  };

  const newData = customerDetail?.customercompanies?.map((item) => ({
    ...item,
    toggleStatus: item?.status,
  }));


  const TableHeading = [
    { value: "companyName", label: "Company Name" },
    { value: "email", label: "Email" },
    { value: "phone", label: "Phone" },
    { value: "gst", label: "GST Number" },
    { value: "address", label: "Address" },
    { value: "toggleStatus", label: "Status" },
  ];

  const ActionData = [
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      clickHandler: HandleUpdate,
    },
  ];

  const handleStatusToggle = (data, status) => {
    let submitData = {};
    submitData = {
      status: status ? 0 : 1,
    };
    const options = {
      method: "POST",
      data: submitData,
    };
    let API = apiUrl?.update_customer_company + `?customerCompanyId=${data?.id}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        toast.success(response?.message);
        GetCustomerDetail();
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <>
      <div className="content container-fluid">
        <MainHeading title="Customer Detail" showBackButton={true} />
        <div className="card manage-user-list">
          <div className="card-body">
            <ul
              className={
                isLoading
                  ? "row list-unstyled mt-4 loading-skeleton"
                  : "row list-unstyled mt-4"
              }
            >
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Customer Name :-
                  </span>
                  {customerDetail?.name || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">Email :-</span>
                  {customerDetail?.email || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">Phone :-</span>
                  {customerDetail?.phone || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">GST Number :-</span>
                  {customerDetail?.gstNumber || "--"}
                </p>
              </li>
              <li className="col-12">
                <p>
                  <span className="text-muted fs-5 d-block">Address :-</span>
                  {customerDetail?.address || "--"}
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className="card mb-4">
          <div className="card-body">
            <MainHeading
              title={"Customer Companies"}
              buttonText={"Add Company"}
              buttonIcon={<PlusIcon />}
              clickHandler={() => {
                setEditData("")
                toggle();
              }}
            />
            <CommonTable
              TableHeading={TableHeading}
              TableData={newData}
              ActionData={ActionData}
              handleStatusToggle={handleStatusToggle}
            />
          </div>
        </div>
      </div>
      <AddCustomerCompanyModal
        modal={modal}
        toggle={toggle}
        customerId={id}
        GetCustomerCompanyList={GetCustomerDetail}
        modalData={EditData}
      />
    </>
  );
}
